import React, {useState} from "react"
import Modal from "../../components/My/Modal";
import {Button} from "../../components/My/Button";
import {Form} from "react-final-form";
import {apiImportExternalTickets} from "./Actions";
import Toast from "cogo-toast";
import FileField from "./FileField";


const ArenaExternTicketsModal = ({visible, close, event}) => {

    let submit
    let [loading, setLoading] = useState(false)
    let [uploadedFile, setUploadedFile] = useState(null)

    if (!visible) return null

    const submitForm = (values) => {
        setLoading(true)
        values.file = uploadedFile

        let formData = new FormData();
        formData.append("files", uploadedFile)
        formData.append("eventId", event.id)

        apiImportExternalTickets((formData), (data) => {
            setLoading(false)
            Toast.success("Úspěšně přidáno.")
            onClose(true)
        }, error => {
            Toast.warn(error?.message)
            setLoading(false)
        })

    }

    const onClose = (refresh) =>{
        setUploadedFile(null)
        close(refresh)
    }

    const validate = (values) => {
        let errors = {};

        if (!uploadedFile) {
            errors.file = "File is required!";
        }

        return errors;
    }

    return (
        <>
            <Modal title={"Import nových externích kódů"}
                   body={
                       <Form
                           validate={validate}
                           onSubmit={submitForm}
                           render={({handleSubmit, errors, values, touched, submitting}) => {
                               submit = handleSubmit
                               return (
                                   <>
                                       <div className={"flex justify-center"}>
                                           <h4>Událost: {event.name}</h4>
                                       </div>
                                       <div className={"w-full"}>
                                           <FileField name={"file"} onChange={setUploadedFile}/>
                                           {errors.file && submitting &&
                                               <div className={"text-red-500 mt-2"}>{errors.file}</div>}
                                       </div>
                                   </>
                               )
                           }}/>
                   }
                   visible={visible}
                   close={() => onClose(false)}
                   footer={<>
                       <Button text={"Potvrdit"} onClick={() => uploadedFile && submit()} loading={loading}/>
                   </>
                   }
            />
        </>
    )
}

export default ArenaExternTicketsModal
